import { Search, Users, Zap, Repeat, Brain, ChevronRight } from "lucide-react";
import { Reveal } from "@/components/web/home/primitives";

/* The recurring TeamNest framework, shown right under the hero:
   Ask · Collaborate · Do · Automate · Remember. */
const STEPS = [
  { icon: Search, label: "Ask", desc: "Research with AI.", tone: "ai" },
  { icon: Users, label: "Collaborate", desc: "Work with people.", tone: "brand" },
  { icon: Zap, label: "Do", desc: "Turn answers into action.", tone: "brand" },
  { icon: Repeat, label: "Automate", desc: "Repeat what works.", tone: "brand" },
  { icon: Brain, label: "Remember", desc: "Build lasting knowledge.", tone: "ai" },
];

export default function FrameworkStrip() {
  return (
    <section className="relative px-5 pb-10 md:pb-14" data-testid="home-framework-strip">
      <div className="max-w-6xl mx-auto">
        <Reveal>
          <div className="rounded-[18px] border border-[var(--w-hairline)] bg-[var(--w-surface)] px-5 py-6 sm:px-8 sm:py-7">
            <div className="text-[11px] font-bold uppercase tracking-[0.16em] text-[var(--w-text-mute)] mb-6 text-center">
              Ask. Collaborate. Do. Automate. Remember.
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 lg:gap-2 items-stretch">
              {STEPS.map((s, i) => {
                const accent = s.tone === "ai" ? "var(--w-ai)" : "var(--w-brand)";
                const tint = s.tone === "ai" ? "var(--w-ai-tint)" : "var(--w-brand-tint)";
                return (
                  <div key={s.label} className="flex items-center gap-2 lg:gap-1">
                    <div className="flex-1 flex items-start gap-3 lg:flex-col lg:items-center lg:text-center">
                      <span
                        className="w-10 h-10 rounded-xl flex items-center justify-center shrink-0"
                        style={{ background: tint }}
                      >
                        <s.icon className="w-5 h-5" style={{ color: accent }} />
                      </span>
                      <div className="lg:mt-3">
                        <div className="text-[15px] font-bold text-[var(--w-text)]">{s.label}</div>
                        <div className="text-[12.5px] leading-5 text-[var(--w-text-dim)] mt-0.5">{s.desc}</div>
                      </div>
                    </div>
                    {i < STEPS.length - 1 && (
                      <ChevronRight className="hidden lg:block w-4 h-4 text-[var(--w-text-mute)] shrink-0 self-center" aria-hidden />
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
